import { lazy, Suspense } from 'react';
import type { DocumentViewerProps } from './document-viewer.types';
import { getViewerLoader, resolveViewerKind, type ViewerKind } from './document-viewer-registry';
import { DocumentViewerSkeleton } from './PdfViewer.lazy';

export type { DocumentViewerProps } from './document-viewer.types';

const PdfDocumentViewer = lazy(getViewerLoader('pdf'));
const DocxHtmlDocumentViewer = lazy(getViewerLoader('docx_html'));
const XlsxDocumentViewer = lazy(getViewerLoader('xlsx'));
const PptxDocumentViewer = lazy(getViewerLoader('pptx'));
const UnsupportedDocumentViewer = lazy(getViewerLoader('unsupported'));

function ResolvedDocumentViewer({
  props,
  viewerKind,
}: {
  props: DocumentViewerProps;
  viewerKind: ViewerKind;
}) {
  switch (viewerKind) {
    case 'pdf':
      return <PdfDocumentViewer {...props} />;
    case 'docx_html':
      return <DocxHtmlDocumentViewer {...props} />;
    case 'xlsx':
      return <XlsxDocumentViewer {...props} />;
    case 'pptx':
      return <PptxDocumentViewer {...props} />;
    case 'unsupported':
      return <UnsupportedDocumentViewer {...props} />;
  }
}

export function DocumentViewer({
  citation,
  documentId,
  filename,
  mediaType,
  onClose,
  sourceUrl,
}: DocumentViewerProps) {
  const anchor = citation?.anchor ?? null;
  const viewerKind = resolveViewerKind(anchor, mediaType);
  const viewerProps = {
    citation,
    documentId,
    filename,
    mediaType,
    onClose,
    sourceUrl,
  };

  return (
    <Suspense fallback={<DocumentViewerSkeleton />}>
      <ResolvedDocumentViewer props={viewerProps} viewerKind={viewerKind} />
    </Suspense>
  );
}
